var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Info Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 19.5C0.75 9.15187 9.15 0.75 19.5 0.75C29.8687 0.75 38.25 9.15187 38.25 19.5C38.25 29.8519 29.8687 38.25 19.5 38.25C9.15 38.25 0.75 29.8519 0.75 19.5ZM17.8516 12.3922C17.8516 11.4941 18.6016 10.7422 19.5016 10.7422C20.4016 10.7422 21.1328 11.4941 21.1328 12.3922V20.6797C21.1328 21.5816 20.4016 22.3109 19.5016 22.3109C18.6016 22.3109 17.8516 21.5816 17.8516 20.6797V12.3922ZM19.5172 28.2734C18.5984 28.2734 17.8672 27.5234 17.8672 26.6234C17.8672 25.7234 18.5984 24.9922 19.4984 24.9922C20.4172 24.9922 21.1484 25.7234 21.1484 26.6234C21.1484 27.5234 20.4172 28.2734 19.5172 28.2734Z",
    fill: "url(#paint0_linear_115_7136)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_7136",
    x1: 6,
    y1: 19,
    x2: 40.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E0B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FD394"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenInfoIcon);
export default __webpack_public_path__ + "static/media/greenInfoIcon.92375c762921ff753fe04f81895bad0a.svg";
export { ForwardRef as ReactComponent };